<template>
  <div class="scope-edition-available-roles">
    <h1 class="display-1 mt-4">Available roles</h1>
    <v-text-field
      v-model="search"
      clearable
      flat
      class="mx-2 my-4"
      prepend-inner-icon="search"
      label="Search"
    ></v-text-field>
    <v-card class="ma-2">
      <v-list two-line v-if="filteredRoles.length > 0" max-height="400px" class="overflow-y-auto">
        <template v-for="(role, index) in filteredRoles">
          <v-list-item :key="role.uuid">
            <v-list-item-content>
              <v-list-item-title v-text="role.name"></v-list-item-title>
              <v-list-item-subtitle v-text="role.description"></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn
                color="success"
                class="pa-2 text-right"
                small
                @click="$emit('add', role.uuid, role.name)"
              >Add</v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="index + 1 < filteredRoles.length" :key="index"></v-divider>
        </template>
      </v-list>
      <div v-else>
        <v-row justify="center" align="center">
          <v-icon size="64" class="my-5" left>sentiment_dissatisfied</v-icon>
          <span class="title">No content</span>
        </v-row>
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    availableRoles: { type: Array }
  },
  data() {
    return {
      search: null
    };
  },
  computed: {
    filteredRoles() {
      var searchValue = this.search ? this.search : "";
      return this.availableRoles.filter(role =>
        role.name.toLowerCase().includes(searchValue.toLowerCase())
      );
    }
  }
};
</script>